<template>
  <div class="container">
    <div class="title">
      <el-breadcrumb separator="/">
        <el-breadcrumb-item>设施运维</el-breadcrumb-item>
        <el-breadcrumb-item>运维管理</el-breadcrumb-item>
        <el-breadcrumb-item>巡检服务</el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <div class="title-en">搜索条件</div>
    <el-card class="box-card">
      <div class="search-container">
        <el-form :inline="true" :model="searchForm" class="search-form" label-width="150px">
          <el-row :gutter="20">
            <el-col :span="6">
              <el-form-item label="工单ID">
                <el-input v-model="searchForm.TicketId" placeholder="请输入工单ID"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="区域">
                <el-select clearable v-model="searchForm.CampusName" placeholder="请选择">
                  <el-option label="张家口-怀来瑞北" value="张家口-怀来瑞北"></el-option>
                  <el-option label="清远-清新" value="清远-清新"></el-option>
                  <el-option label="清远-清城" value="清远-清城"></el-option>
                  <el-option label="深圳-滨海腾大" value="深圳-滨海腾大"></el-option>
                  <el-option label="贵阳-贵安七星" value="贵阳-贵安七星"></el-option>
                  <el-option label="天津-滨海高新" value="天津-滨海高新"></el-option>
                  <el-option label="南京-江宁" value="南京-江宁"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="计划开始时间">
                <el-date-picker
                  v-model="searchForm.createTime"
                  type="daterange"
                  range-separator="-"
                  style="width: 100%"
                  start-placeholder="开始日期"
                  end-placeholder="结束日期"
                  value-format="yyyy-MM-dd"
                  @change="handleDateChange"
                >
                </el-date-picker>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="20">
            <el-col :span="6">
              <div class="search-button">
                <el-button type="primary" @click="handleSearch">点击查询</el-button>
                <el-button @click="handleReset">重置</el-button>
                <el-button @click="debouncedExport">{{ exportButtonText }}</el-button>
              </div>
            </el-col>
          </el-row>
        </el-form>
      </div>
    </el-card>
    <el-tabs v-model="activeTab" class="custom-tabs" @tab-click="handleTabChange">
      <el-tab-pane label="数据分析" name="analysis">
        <div class="title-en">数据分析</div>
        <el-card class="box-card">
          <div class="analysis-container">
            <ManpowerAnalysis :tableData="tableDataAll" />
          </div>
        </el-card>
      </el-tab-pane>
      <el-tab-pane label="巡检服务列表" name="list">
        <div class="title-en">巡检服务列表</div>
        <el-card class="box-card">
          <div class="table-container">
            <div class="button-container">
              <el-button @click="openColumnsDialog">表头设置</el-button>
            </div>
            <el-table
              :data="tableData"
              border
              stripe
              @selection-change="handleSelectionChange"
              ref="table"
              v-loading="loading"
            >
              <el-table-column type="selection" width="55" align="center"></el-table-column>
              <el-table-column
                type="index"
                label="序号"
                width="60"
                align="center"
              ></el-table-column>
              <el-table-column
                v-for="(column, index) in visibleColumns"
                :key="index"
                :prop="column.prop"
                :label="column.label"
                :width="column.width"
              >
                <template slot-scope="scope">
                  <span
                    v-if="
                      column.prop === 'CreateTime' ||
                      column.prop === 'UpdateTime' ||
                      column.prop === 'PlanStartTime' ||
                      column.prop === 'RealStartTime' ||
                      column.prop === 'RealEndTime'
                    "
                    >{{
                      scope.row[column.prop]
                        ? $moment(scope.row[column.prop]).format('YYYY-MM-DD')
                        : '-'
                    }}</span
                  >
                  <span v-else>{{ scope.row[column.prop] || '-' }}</span>
                </template>
              </el-table-column>
            </el-table>

            <el-dialog
              title="设置显示项"
              :visible.sync="showColumnsDialog"
              :append-to-body="true"
              width="400px"
              :close-on-click-modal="false"
              custom-class="columns-dialog"
              :modal-append-to-body="false"
              :destroy-on-close="true"
            >
              <el-checkbox-group v-model="selectedColumns" class="checkbox-group">
                <el-checkbox
                  v-for="column in columns"
                  :key="column.prop"
                  :label="column.prop"
                  class="checkbox-item"
                >
                  {{ column.label }}
                </el-checkbox>
              </el-checkbox-group>
              <div slot="footer" class="dialog-footer">
                <el-button size="small" @click="selectAllColumns">全选</el-button>
                <el-button size="small" @click="restoreDefaultColumns">恢复默认</el-button>
                <el-button size="small" type="primary" @click="saveColumnsDialog">保存</el-button>
              </div>
            </el-dialog>

            <div class="pagination-container">
              <el-pagination
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                :current-page="currentPage"
                :page-sizes="[10, 20, 30, 50]"
                :page-size="pageSize"
                layout="total, sizes, prev, pager, next, jumper"
                :total="total"
              />
            </div>
          </div>
        </el-card>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
import { getInspectionMsg, getInspectionMsgAll } from '@/api/operation';

import { debounce } from 'lodash';
import * as XLSX from 'xlsx';
import ManpowerAnalysis from './analysis.vue';

export default {
  name: 'ManpowerService',
  components: {
    ManpowerAnalysis,
  },
  data() {
    return {
      activeTab: 'analysis',
      debouncedExport: null,
      tableData: [],
      searchForm: {
        TicketId: '',
        CampusName: '',
        MozuName: '',
        TaskName: '',
        InspType: '',
        PlanStartTime: '',
        RealStartTime: '',
        RealEndTime: '',
        InspStatus: '',
        createTime: [],
        UpdateTime: '',
        start_time: '',
        end_time: '',
      },
      currentPage: 1,
      pageSize: 10,
      total: 0,
      showColumnsDialog: false,
      selectedColumns: [
        'TicketId',
        'CampusName',
        'MozuName',
        'TaskName',
        'InspType',
        'PlanningStartTime',
        'RealStartTime',
        'RealEndTime',
        'InspStatus',
        'CreateTime',
        'UpdateTime',
        'TodoUser',
        'RealTodoUser',
        'RealMonitor',
        'CheckResult',
        'UnpassExplain',
        'IsAbnormal',
        'AbnormalCount',
        'IsTimeout',
        'Duration',
        'TimeoutDuration',
        'PauseDuration',
        'Rate',
        'ServiceStatus',
        'ServiceApprover',
        'ServiceDetail',
        'FmcStatus',
        'FmcApprover',
        'FmcDetail',
        'ReInspCount',
        'Score',
      ],
      defaultSelectedColumns: [
        'TicketId',
        'CampusName',
        'MozuName',
        'TaskName',
        'InspType',
        'PlanningStartTime',
        'RealStartTime',
        'RealEndTime',
        'InspStatus',
        'CreateTime',
        'UpdateTime',
        'TodoUser',
        'RealTodoUser',
        'RealMonitor',
        'CheckResult',
        'UnpassExplain',
        'IsAbnormal',
        'AbnormalCount',
        'IsTimeout',
        'Duration',
        'TimeoutDuration',
        'PauseDuration',
        'Rate',
        'ServiceStatus',
        'ServiceApprover',
        'ServiceDetail',
        'FmcStatus',
        'FmcApprover',
        'FmcDetail',
        'ReInspCount',
        'Score',
      ],
      columns: [
        { prop: 'TicketId', label: '工单ID', width: 150 },
        { prop: 'CampusName', label: '区域园区', width: 150 },
        { prop: 'MozuName', label: '模组', width: 150 },
        { prop: 'TaskName', label: '任务名称', width: 400 },
        { prop: 'InspType', label: '巡检类型', width: 150 },
        { prop: 'PlanningStartTime', label: '计划开始时间', width: 150 },
        { prop: 'RealStartTime', label: '实际巡检开始时间', width: 150 },
        { prop: 'RealEndTime', label: '实际巡检结束时间', width: 150 },
        { prop: 'InspStatus', label: '巡检状态', width: 150 },
        { prop: 'CreateTime', label: '创建时间', width: 150 },
        { prop: 'UpdateTime', label: '更新时间', width: 150 },
        { prop: 'TodoUser', label: '计划巡检人', width: 150 },
        { prop: 'RealTodoUser', label: '实际巡检人', width: 150 },
        { prop: 'RealMonitor', label: '实际审核人', width: 150 },
        { prop: 'CheckResult', label: '值班长审核结果', width: 150 },
        { prop: 'UnpassExplain', label: '不通过原因', width: 150 },
        { prop: 'IsAbnormal', label: '是否异常', width: 150 },
        { prop: 'AbnormalCount', label: '异常数量', width: 150 },
        { prop: 'IsTimeout', label: '是否超时', width: 150 },
        { prop: 'Duration', label: '巡检时长', width: 150 },
        { prop: 'TimeoutDuration', label: '超时时长', width: 150 },
        { prop: 'PauseDuration', label: '暂停时长', width: 150 },
        { prop: 'Rate', label: '巡检通过率', width: 150 },
        { prop: 'ServiceStatus', label: '服务审批状态', width: 150 },
        { prop: 'ServiceApprover', label: '服务审批人', width: 150 },
        { prop: 'ServiceDetail', label: '服务审批说明', width: 150 },
        { prop: 'FmcStatus', label: 'FMC审批状态', width: 150 },
        { prop: 'FmcApprover', label: 'FMC审批人', width: 150 },
        { prop: 'FmcDetail', label: 'FMC审批说明', width: 150 },
        { prop: 'ReInspCount', label: '重检次数', width: 150 },
        { prop: 'Score', label: '评分', width: 150 },
      ],
      visibleColumns: [],
      selectedRows: [],
      loading: false,
      tableDataAll: [],
    };
  },
  created() {
    this.visibleColumns = this.columns.filter((column) =>
      this.selectedColumns.includes(column.prop)
    );
    // 设置默认时间范围为当前自然月
    const now = new Date();
    const firstDay = new Date(now.getFullYear(), now.getMonth(), 1);
    const lastDay = new Date(now.getFullYear(), now.getMonth() + 1, 0);
    this.searchForm.createTime = [
      this.$moment(firstDay).format('YYYY-MM-DD'),
      this.$moment(lastDay).format('YYYY-MM-DD'),
    ];
    this.searchForm.start_time = this.$moment(firstDay).format('YYYY-MM-DD');
    this.searchForm.end_time = this.$moment(lastDay).format('YYYY-MM-DD');
    this.fetchData();
    this.fetchDataAll();
    this.handleDateChange(this.searchForm.createTime);
    // 创建防抖后的导出函数
    this.debouncedExport = debounce(this.handleExport, 300);
  },
  methods: {
    handleTabChange(tab) {
      if (tab.index === '0') {
        this.fetchDataAll();
      } else {
        this.fetchData();
      }
    },
    handleDateChange(dates) {
      if (dates) {
        this.searchForm.createTime = dates;
        this.searchForm.start_time = this.$moment(dates[0]).format('YYYY-MM-DD');
        this.searchForm.end_time = this.$moment(dates[1]).format('YYYY-MM-DD');
      } else {
        // 如果清空日期，重置为当前自然月
        const now = new Date();
        const firstDay = new Date(now.getFullYear(), now.getMonth(), 1);
        const lastDay = new Date(now.getFullYear(), now.getMonth() + 1, 0);
        this.searchForm.createTime = [
          this.$moment(firstDay).format('YYYY-MM-DD'),
          this.$moment(lastDay).format('YYYY-MM-DD'),
        ];
        this.searchForm.start_time = this.$moment(firstDay).format('YYYY-MM-DD');
        this.searchForm.end_time = this.$moment(lastDay).format('YYYY-MM-DD');
      }
    },
    async fetchData() {
      const params = {
        page: this.currentPage,
        size: this.pageSize,
        CampusName: this.searchForm.CampusName || null,
        TicketId: this.searchForm.TicketId || null,
        start_time: this.searchForm.start_time,
        end_time: this.searchForm.end_time,
      };

      // 添加结束时间的时分秒
      if (params.end_time) {
        params.end_time = this.$moment(params.end_time).format('YYYY-MM-DD');
      }

      this.loading = true;

      try {
        const response = await getInspectionMsg(params);
        if (response.data) {
          this.tableData = response.data.data.data || [];
          this.total = response.data.data.counts || 0;
        }
      } catch (error) {
        console.error('请求错误:', error);
        let errorMessage = '获取数据失败';
        if (error.response && error.response.status === 422) {
          errorMessage = '请求参数格式不正确，请检查输入';
        }
        this.$message.error(errorMessage);
      } finally {
        this.loading = false;
      }
    },
    async fetchDataAll() {
      const params = {
        CampusName: this.searchForm.CampusName || null,
        TicketId: this.searchForm.TicketId || null,
        start_time: this.searchForm.start_time,
        end_time: this.searchForm.end_time,
      };

      // 添加结束时间的时分秒
      if (params.end_time) {
        params.end_time = this.$moment(params.end_time).format('YYYY-MM-DD');
      }

      this.loading = true;

      try {
        const response = await getInspectionMsgAll(params);
        if (response.data) {
          this.tableDataAll = response.data.data.data || [];
          this.total = response.data.data.counts || 0;
        }
      } catch (error) {
        console.error('请求错误:', error);
        let errorMessage = '获取数据失败';
        if (error.response && error.response.status === 422) {
          errorMessage = '请求参数格式不正确，请检查输入';
        }
        this.$message.error(errorMessage);
      } finally {
        this.loading = false;
      }
    },
    handleSearch() {
      this.currentPage = 1;
      if (this.activeTab === 'analysis') {
        this.fetchDataAll();
      } else {
        this.fetchData();
      }
    },
    handleReset() {
      // 重置所有搜索条件
      this.searchForm = {
        TicketId: '',
        CampusName: '',
        MozuName: '',
        TaskName: '',
        InspType: '',
        PlanStartTime: '',
        RealStartTime: '',
        RealEndTime: '',
        InspStatus: '',
        CreateTime: '',
        UpdateTime: '',
        start_time: '',
        end_time: '',
      };
      // 重置为当前自然月
      const now = new Date();
      const firstDay = new Date(now.getFullYear(), now.getMonth(), 1);
      const lastDay = new Date(now.getFullYear(), now.getMonth() + 1, 0);
      this.searchForm.start_time = this.$moment(firstDay).format('YYYY-MM-DD');
      this.searchForm.end_time = this.$moment(lastDay).format('YYYY-MM-DD');
      this.currentPage = 1;
      this.fetchData();
    },
    openColumnsDialog() {
      this.showColumnsDialog = true;
    },
    saveColumnsDialog() {
      this.showColumnsDialog = false;
      this.visibleColumns = this.columns.filter((column) =>
        this.selectedColumns.includes(column.prop)
      );
    },
    selectAllColumns() {
      this.selectedColumns = this.columns.map((column) => column.prop);
    },
    restoreDefaultColumns() {
      this.selectedColumns = [...this.defaultSelectedColumns];
    },
    handleSizeChange(val) {
      this.pageSize = val;
      this.currentPage = 1;
      this.fetchData();
    },
    handleCurrentChange(val) {
      this.currentPage = val;
      this.fetchData();
    },

    handleSelectionChange(selection) {
      this.selectedRows = selection;
    },
    async handleExport() {
      this.exportLoading = true;
      try {
        if (this.selectedRows.length === 0) {
          // 导出全部数据
          this.loading = true;
          // TODO: 替换为实际的导出API
          const response = await getInspectionMsg({
            CampusName: this.searchForm.CampusName || null,
            TicketId: this.searchForm.TicketId || null,
            start_time: this.searchForm.start_time,
            end_time: this.searchForm.end_time,
            export_excel: 1,
          });

          if (response.data) {
            this.loading = false;
            const allData = response.data.data.data || [];
            const worksheetData = allData.map((row) => {
              const rowData = {};
              this.visibleColumns.forEach((column) => {
                if (column.prop !== 'operation') {
                  let value = row[column.prop];
                  if (
                    [
                      'CreateTime',
                      'UpdateTime',
                      'PlanStartTime',
                      'RealStartTime',
                      'RealEndTime',
                    ].includes(column.prop)
                  ) {
                    value = value ? this.$moment(value).format('YYYY-MM-DD') : '-';
                  }
                  rowData[column.label] = value || '-';
                }
              });
              return rowData;
            });

            const worksheet = XLSX.utils.json_to_sheet(worksheetData);

            const colWidths = {};
            this.visibleColumns.forEach((column, index) => {
              const width = column.width ? Math.ceil(parseInt(column.width) / 7) : 10;
              colWidths[XLSX.utils.encode_col(index)] = { wch: width };
            });
            worksheet['!cols'] = Object.values(colWidths);

            const workbook = XLSX.utils.book_new();
            XLSX.utils.book_append_sheet(workbook, worksheet, '巡检服务');

            const timestamp = this.$moment().format('YYYYMMDDHHmmss');
            const filename = `人力服务_${timestamp}.xlsx`;

            XLSX.writeFile(workbook, filename);
            this.$message.success('导出成功');
          }
        } else {
          const worksheetData = this.selectedRows.map((row) => {
            const rowData = {};
            this.visibleColumns.forEach((column) => {
              if (column.prop !== 'operation') {
                let value = row[column.prop];
                if (
                  [
                    'CreateTime',
                    'UpdateTime',
                    'PlanStartTime',
                    'RealStartTime',
                    'RealEndTime',
                  ].includes(column.prop)
                ) {
                  value = value ? this.$moment(value).format('YYYY-MM-DD') : '-';
                }
                rowData[column.label] = value || '-';
              }
            });
            return rowData;
          });

          const worksheet = XLSX.utils.json_to_sheet(worksheetData);

          const colWidths = {};
          this.visibleColumns.forEach((column, index) => {
            const width = column.width ? Math.ceil(parseInt(column.width) / 7) : 10;
            colWidths[XLSX.utils.encode_col(index)] = { wch: width };
          });
          worksheet['!cols'] = Object.values(colWidths);

          const workbook = XLSX.utils.book_new();
          XLSX.utils.book_append_sheet(workbook, worksheet, '巡检服务');

          const timestamp = this.$moment().format('YYYYMMDDHHmmss');
          const filename = `人力服务_${timestamp}.xlsx`;

          XLSX.writeFile(workbook, filename);
          this.$message.success('导出成功');
        }
      } catch (error) {
        console.error('导出错误:', error);
        this.$message.error('导出失败，请重试');
      } finally {
        this.exportLoading = false;
        this.loading = false;
      }
    },
  },
  computed: {
    exportButtonText() {
      return this.selectedRows.length > 0 ? `导出已选(${this.selectedRows.length})` : '导出全部';
    },
  },
  watch: {
    selectedColumns(val) {
      this.selectAll = val.length === this.columns.length;
      this.isIndeterminate = val.length > 0 && val.length < this.columns.length;
    },
  },
};
</script>

<style scoped>
.custom-tabs {
  margin-bottom: 20px;
}
.analysis-container {
  min-height: 400px;
  padding: 20px;
}
.placeholder {
  color: #909399;
  font-size: 16px;
}
.container {
  padding: 20px;
}
.title {
  font-size: 24px;
  font-weight: bold;
  margin-bottom: 30px;
}
.search-container {
  padding: 20px;
  background-color: #fff;
  border-radius: 4px;
}

.search-form {
  width: 100%;
}

.search-button {
  display: flex;
  justify-content: flex-start;
  align-items: flex-start;
  margin-left: 13px;
}

/* 调整表单项间距 */
.el-form-item {
  margin-bottom: 18px;
  display: flex;
}

.button-container {
  margin-bottom: 20px;
  display: flex;
  justify-content: flex-end;
  position: relative;
}
.box-card {
  margin-bottom: 20px;
}
.pagination-container {
  display: flex;
  justify-content: flex-end;
}
.title-en {
  margin: 10px 0;
  padding-left: 10px;
  border-left: 3px solid #219aff;
  font-weight: normal;
}
.columns-dialog {
  margin-top: 0 !important;
  position: absolute !important;
  margin-left: 0 !important;
  top: 100% !important;
  left: 0 !important;
  transform: none !important;
}

.el-dialog__wrapper.columns-dialog {
  position: absolute !important;
  overflow: visible !important;
}

.button-container {
  margin-bottom: 20px;
  display: flex;
  justify-content: flex-end;
  position: relative;
}
.checkbox-group {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 12px;
  padding: 10px;
  max-height: 300px;
  overflow-y: auto;
}

.checkbox-item {
  margin-right: 0;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.dialog-footer {
  text-align: right;
  padding-top: 15px;
  border-top: 1px solid #ebeef5;
}

.dialog-footer .el-button + .el-button {
  margin-left: 8px;
}

/* 修改日期选择器宽度 */
::v-deep .el-date-editor.el-input__inner,
.el-date-editor--daterange.el-input__inner {
  width: 100% !important;
}

::v-deep .el-range-editor.el-input__inner {
  width: 100% !important;
}
::v-deep .el-date-editor .el-range-input {
  width: 66% !important;
}
::v-deep .el-range-editor--small .el-range-input {
  font-size: 12px !important;
}
/* 统一下拉框和输入框宽度 */
::v-deep .el-select,
.el-input {
  width: 100% !important;
}
::v-deep .el-form-item__content {
  width: calc(100% - 10px) !important;
}
::v-deep .el-tabs__nav-wrap::after {
  height: 1px !important;
}
</style>
  